// AUTO-GENERATED by asyncapi-cable from the cable AsyncAPI documents.
// Do not edit by hand — regenerate with the asyncapi-cable CLI.

import { Channel } from "@anycable/core";
import type { UserPresenceMessage } from "../models/UserPresenceMessage";

/** Alternatives declared for the operation — AsyncAPI treats a channel's messages as a union. */
export type UserPresenceData = UserPresenceMessage;

/** Params the client supplies at subscribe time. */
export type UserPresenceParams = Record<string, never>;

export class UserPresenceChannel extends Channel<UserPresenceParams, UserPresenceData> {
  static identifier = "UserPresenceChannel";
}
